import { nanoid } from 'nanoid'

// member role is setting by default if userGroupRole not selected
export const translateRole = (selectedRole) => {
  switch (selectedRole) {
    case 'admin':
      return ['admin', null]
    case 'group_admin':
      return ['user', 'admin']
    default:
      return ['user', null]
  }
}

export const buildInvitation = (email, userGroupId) => {
  const [role, userGroupRole] = translateRole('user')
  return { id: nanoid(5), email, role, userGroupRole, displayRole: 'user', userGroupId }
}

export const translateBackendErrorsToForm = (payload) => {
  const errorsMap = Object.keys(payload).map((index) => (
    Object.entries(payload[index]).map(([field, value]) => (
      [`invitations.${index}.${field}`, [value]]
    ))
  )).flat()

  return Object.fromEntries(errorsMap)
}
